import React from 'react';
import { motion } from 'framer-motion';
import TopicsIcon from '../../assets/svg/Blog/TopicsIcon.svg';

const EmptyState = ({ message = "No blog posts found.", description = "Try adjusting your search or category filters." }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex flex-col items-center justify-center py-20 px-4 text-center bg-gray-50 rounded-2xl border-2 border-dashed border-gray-200"
        >
            <img src={TopicsIcon} alt="No results" className="w-24 h-24 mb-6 opacity-40" />
            <h3 className="text-xl font-bold text-gray-800 mb-2">{message}</h3>
            <p className="text-gray-500 max-w-xs">{description}</p>
        </motion.div>
    );
};

export default EmptyState;
